// // src/components/admin/CertificationManager.jsx
// import React, { useState, useEffect } from 'react';
// import { getCertifications, createCertification, updateCertification, deleteCertification } from '../../utils/api';
// import toast from 'react-hot-toast';

// const CertificationManager = () => {
//     const [certifications, setCertifications] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [showForm, setShowForm] = useState(false);
//     const [editingId, setEditingId] = useState(null);
//     const [formData, setFormData] = useState({
//         name: '',
//         issuer: '',
//         issue_date: '',
//         expiry_date: '',
//         certificate_number: '',
//         image_url: '',
//         is_active: true
//     });

//     useEffect(() => {
//         loadCertifications();
//     }, []);

//     const loadCertifications = async () => {
//         try {
//             setLoading(true);
//             const data = await getCertifications();
            
//             // Handle different response structures
//             if (Array.isArray(data)) {
//                 setCertifications(data);
//             } else if (data && data.data && Array.isArray(data.data)) {
//                 setCertifications(data.data);
//             } else {
//                 setCertifications([]);
//             }
//         } catch (error) {
//             console.error('Error loading certifications:', error);
//             toast.error('Failed to load certifications');
//             setCertifications([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (editingId) {
//                 await updateCertification(editingId, formData);
//                 toast.success('Certification updated successfully!');
//             } else {
//                 await createCertification(formData);
//                 toast.success('Certification added successfully!');
//             }
            
//             resetForm();
//             await loadCertifications();
            
//         } catch (error) {
//             console.error('Error saving certification:', error);
//             const errorMessage = error.response?.data?.message || 'Failed to save certification';
//             toast.error(errorMessage);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm('Are you sure you want to delete this certification?')) {
//             try {
//                 await deleteCertification(id);
//                 toast.success('Certification deleted successfully!');
//                 await loadCertifications();
//             } catch (error) {
//                 console.error('Error deleting certification:', error);
//                 toast.error('Failed to delete certification');
//             }
//         }
//     };

//     const handleEdit = (cert) => {
//         setFormData({
//             name: cert.name || '',
//             issuer: cert.issuer || '',
//             issue_date: cert.issue_date?.split('T')[0] || '',
//             expiry_date: cert.expiry_date?.split('T')[0] || '',
//             certificate_number: cert.certificate_number || '',
//             image_url: cert.image_url || '',
//             is_active: cert.is_active !== undefined ? cert.is_active : true
//         });
//         setEditingId(cert.id);
//         setShowForm(true);
//     };

//     const resetForm = () => {
//         setFormData({
//             name: '',
//             issuer: '',
//             issue_date: '',
//             expiry_date: '',
//             certificate_number: '',
//             image_url: '',
//             is_active: true
//         });
//         setEditingId(null);
//         setShowForm(false);
//     };

//     const handleToggleActive = async (id, currentStatus) => {
//         try {
//             await updateCertification(id, { is_active: !currentStatus });
//             toast.success(`Certification ${!currentStatus ? 'activated' : 'deactivated'}`);
//             await loadCertifications();
//         } catch (error) {
//             console.error('Error toggling certification status:', error);
//             toast.error('Failed to update certification status');
//         }
//     };

//     return (
//         <div className="bg-white p-6 rounded-lg shadow">
//             <div className="flex justify-between items-center mb-6">
//                 <h2 className="text-2xl font-bold text-gray-800">Certifications</h2>
//                 <button
//                     onClick={() => {
//                         resetForm();
//                         setShowForm(true);
//                     }}
//                     className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
//                 >
//                     Add New Certification
//                 </button>
//             </div>

//             {showForm && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//                     <div className="bg-white p-6 rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//                         <div className="flex justify-between items-center mb-4">
//                             <h3 className="text-xl font-bold">
//                                 {editingId ? 'Edit Certification' : 'Add New Certification'}
//                             </h3>
//                             <button
//                                 onClick={resetForm}
//                                 className="text-gray-500 hover:text-gray-700"
//                             >
//                                 ✕
//                             </button>
//                         </div>
                        
//                         <form onSubmit={handleSubmit} className="space-y-4">
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Certification Name *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.name}
//                                         onChange={(e) => setFormData({...formData, name: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         required
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Issuing Authority *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.issuer}
//                                         onChange={(e) => setFormData({...formData, issuer: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         required
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Issue Date
//                                     </label>
//                                     <input
//                                         type="date"
//                                         value={formData.issue_date}
//                                         onChange={(e) => setFormData({...formData, issue_date: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Expiry Date
//                                     </label>
//                                     <input
//                                         type="date"
//                                         value={formData.expiry_date}
//                                         onChange={(e) => setFormData({...formData, expiry_date: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Certificate Number
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.certificate_number}
//                                         onChange={(e) => setFormData({...formData, certificate_number: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Image URL
//                                     </label>
//                                     <input
//                                         type="url"
//                                         value={formData.image_url}
//                                         onChange={(e) => setFormData({...formData, image_url: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         placeholder="https://example.com/certificate.jpg"
//                                     />
//                                 </div>
//                             </div>
                            
//                             <div className="flex items-center space-x-2">
//                                 <input
//                                     type="checkbox"
//                                     id="is_active"
//                                     checked={formData.is_active}
//                                     onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
//                                     className="rounded text-blue-600 focus:ring-blue-500"
//                                 />
//                                 <label htmlFor="is_active" className="text-sm text-gray-700">
//                                     Active
//                                 </label>
//                             </div>
                            
//                             <div className="flex justify-end space-x-3 pt-4">
//                                 <button
//                                     type="button"
//                                     onClick={resetForm}
//                                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                                 >
//                                     {editingId ? 'Update Certification' : 'Add Certification'}
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {loading ? (
//                 <div className="flex justify-center items-center h-64">
//                     <div className="text-center">
//                         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//                         <p className="mt-4 text-gray-600">Loading certifications...</p>
//                     </div>
//                 </div>
//             ) : certifications.length === 0 ? (
//                 <div className="text-center py-12">
//                     <p className="text-gray-500 text-lg">No certifications found</p>
//                     <p className="text-gray-400 mt-2">Add your first certification to get started</p>
//                 </div>
//             ) : (
//                 <div className="overflow-x-auto">
//                     <table className="min-w-full divide-y divide-gray-200">
//                         <thead className="bg-gray-50">
//                             <tr>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Certification
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Issuer
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Certificate No.
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Status
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Actions
//                                 </th>
//                             </tr>
//                         </thead>
//                         <tbody className="bg-white divide-y divide-gray-200">
//                             {certifications.map(cert => (
//                                 <tr key={cert.id} className="hover:bg-gray-50">
//                                     <td className="px-6 py-4 whitespace-nowrap">
//                                         <div className="flex items-center">
//                                             {cert.image_url && (
//                                                 <img 
//                                                     src={cert.image_url} 
//                                                     alt={cert.name}
//                                                     className="h-10 w-10 rounded-lg object-cover mr-3"
//                                                     onError={(e) => {
//                                                         e.target.onerror = null;
//                                                         e.target.style.display = 'none';
//                                                     }}
//                                                 />
//                                             )}
//                                             <div>
//                                                 <div className="text-sm font-medium text-gray-900">{cert.name}</div>
//                                                 <div className="text-sm text-gray-500">
//                                                     {cert.issue_date && new Date(cert.issue_date).toLocaleDateString()}
//                                                     {cert.expiry_date && ` - ${new Date(cert.expiry_date).toLocaleDateString()}`}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </td>
//                                     <td className="px-6 py-4 whitespace-nowrap">
//                                         <div className="text-sm text-gray-900">{cert.issuer}</div>
//                                     </td>
//                                     <td className="px-6 py-4 whitespace-nowrap">
//                                         <div className="text-sm text-gray-900">{cert.certificate_number || '-'}</div>
//                                     </td>
//                                     <td className="px-6 py-4 whitespace-nowrap">
//                                         <button
//                                             onClick={() => handleToggleActive(cert.id, cert.is_active)}
//                                             className={`px-3 py-1 rounded-full text-xs font-medium ${
//                                                 cert.is_active 
//                                                     ? 'bg-green-100 text-green-800' 
//                                                     : 'bg-red-100 text-red-800'
//                                             }`}
//                                         >
//                                             {cert.is_active ? 'Active' : 'Inactive'}
//                                         </button>
//                                     </td>
//                                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                         <button
//                                             onClick={() => handleEdit(cert)}
//                                             className="text-blue-600 hover:text-blue-900 mr-4"
//                                         >
//                                             Edit
//                                         </button>
//                                         <button
//                                             onClick={() => handleDelete(cert.id)}
//                                             className="text-red-600 hover:text-red-900"
//                                         >
//                                             Delete
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CertificationManager;







import React, { useState, useEffect, useRef } from 'react';
import { getCertifications, createCertification, updateCertification, deleteCertification } from '../../utils/api';
import toast from 'react-hot-toast';

const CertificationManager = () => {
    const [certifications, setCertifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        issuer: '',
        issue_date: '',
        expiry_date: '',
        certificate_number: '',
        image_url: '',
        selectedFile: null,
        filePreview: null,
        is_active: true
    });

    const fileInputRef = useRef(null);
    const FILE_SERVER_URL = process.env.REACT_APP_FILE_SERVER_URL || 'https://nkumbufileserver-production.up.railway.app';

    useEffect(() => {
        loadCertifications();
    }, []);

    const loadCertifications = async () => {
        try {
            setLoading(true);
            const data = await getCertifications();
            
            // Handle different response structures
            if (Array.isArray(data)) {
                setCertifications(data);
            } else if (data && data.data && Array.isArray(data.data)) {
                setCertifications(data.data);
            } else {
                setCertifications([]);
            }
        } catch (error) {
            console.error('Error loading certifications:', error);
            toast.error('Failed to load certifications');
            setCertifications([]);
        } finally {
            setLoading(false);
        }
    };

    // Upload file to Railway file server
    const uploadToFileServer = async (file) => {
        setUploading(true);
        setUploadProgress(0);
        
        try {
            const formData = new FormData();
            formData.append('file', file);

            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = (event.loaded / event.total) * 100;
                        setUploadProgress(Math.round(percentComplete));
                    }
                });

                xhr.addEventListener('load', () => {
                    if (xhr.status === 200) {
                        const response = JSON.parse(xhr.responseText);
                        setUploading(false);
                        setUploadProgress(0);
                        resolve(response.fileInfo.fileUrl);
                    } else {
                        reject(new Error(`Upload failed with status ${xhr.status}`));
                    }
                });

                xhr.addEventListener('error', () => {
                    reject(new Error('Upload failed'));
                });

                xhr.open('POST', `${FILE_SERVER_URL}/upload`);
                xhr.send(formData);
            });
        } catch (error) {
            setUploading(false);
            setUploadProgress(0);
            console.error('Upload error:', error);
            throw error;
        }
    };

    // Handle file selection
    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file size (max 100MB)
        const maxSize = 100 * 1024 * 1024; // 100MB in bytes
        if (file.size > maxSize) {
            toast.error('File size exceeds 100MB limit');
            return;
        }

        // Validate file type (images only for certificates)
        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            toast.error('Please select an image file (JPEG, PNG, GIF, WebP, SVG) or PDF');
            return;
        }

        // Generate preview for images
        let filePreview = null;
        if (file.type.startsWith('image/')) {
            filePreview = URL.createObjectURL(file);
        }

        setFormData(prev => ({
            ...prev,
            selectedFile: file,
            image_url: '',
            filePreview: filePreview
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let imageUrl = formData.image_url;

            // If a new file is selected, upload it to the file server
            if (formData.selectedFile) {
                toast.loading('Uploading certificate image...');
                imageUrl = await uploadToFileServer(formData.selectedFile);
                toast.dismiss();
                toast.success('Certificate uploaded successfully!');
            }

            // Prepare certification data
            const certificationData = {
                name: formData.name,
                issuer: formData.issuer,
                issue_date: formData.issue_date || null,
                expiry_date: formData.expiry_date || null,
                certificate_number: formData.certificate_number,
                image_url: imageUrl,
                is_active: formData.is_active
            };

            if (editingId) {
                await updateCertification(editingId, certificationData);
                toast.success('Certification updated successfully!');
            } else {
                await createCertification(certificationData);
                toast.success('Certification added successfully!');
            }
            
            resetForm();
            await loadCertifications();
            
        } catch (error) {
            console.error('Error saving certification:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to save certification';
            toast.error(errorMessage);
        } finally {
            setUploading(false);
            setUploadProgress(0);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this certification?')) {
            try {
                await deleteCertification(id);
                toast.success('Certification deleted successfully!');
                await loadCertifications();
            } catch (error) {
                console.error('Error deleting certification:', error);
                toast.error('Failed to delete certification');
            }
        }
    };

    const handleEdit = (cert) => {
        // Clean up previous preview if exists
        if (formData.filePreview) {
            URL.revokeObjectURL(formData.filePreview);
        }

        setFormData({
            name: cert.name || '',
            issuer: cert.issuer || '',
            issue_date: cert.issue_date?.split('T')[0] || '',
            expiry_date: cert.expiry_date?.split('T')[0] || '',
            certificate_number: cert.certificate_number || '',
            image_url: cert.image_url || '',
            selectedFile: null,
            filePreview: null,
            is_active: cert.is_active !== undefined ? cert.is_active : true
        });
        setEditingId(cert.id);
        setShowForm(true);
    };

    const resetForm = () => {
        // Clean up preview URL if exists
        if (formData.filePreview) {
            URL.revokeObjectURL(formData.filePreview);
        }
        
        setFormData({
            name: '',
            issuer: '',
            issue_date: '',
            expiry_date: '',
            certificate_number: '',
            image_url: '',
            selectedFile: null,
            filePreview: null,
            is_active: true
        });
        setEditingId(null);
        setShowForm(false);
        setUploadProgress(0);
        setUploading(false);
    };

    const handleToggleActive = async (id, currentStatus) => {
        try {
            await updateCertification(id, { is_active: !currentStatus });
            toast.success(`Certification ${!currentStatus ? 'activated' : 'deactivated'}`);
            await loadCertifications();
        } catch (error) {
            console.error('Error toggling certification status:', error);
            toast.error('Failed to update certification status');
        }
    };

    const handleClearFile = () => {
        if (formData.filePreview) {
            URL.revokeObjectURL(formData.filePreview);
        }
        
        setFormData(prev => ({
            ...prev,
            selectedFile: null,
            filePreview: null
        }));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            
            // Create a fake event object
            const fakeEvent = {
                target: {
                    files: [file]
                }
            };
            
            handleFileSelect(fakeEvent);
        }
    };

    const renderFilePreview = () => {
        if (formData.filePreview) {
            return (
                <div className="relative">
                    <img 
                        src={formData.filePreview} 
                        alt="Preview"
                        className="w-full h-48 object-contain rounded border bg-gray-50"
                    />
                    <button
                        type="button"
                        onClick={handleClearFile}
                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>
            );
        } else if (formData.selectedFile) {
            return (
                <div className="p-3 bg-blue-50 rounded border flex justify-between items-center">
                    <div>
                        <p className="text-sm font-medium text-gray-700">
                            {formData.selectedFile.name}
                        </p>
                        <p className="text-xs text-gray-500">
                            {(formData.selectedFile.size / 1024).toFixed(1)} KB • {formData.selectedFile.type}
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={handleClearFile}
                        className="text-red-500 hover:text-red-700"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            );
        } else if (formData.image_url) {
            return (
                <div className="relative">
                    <img 
                        src={formData.image_url} 
                        alt="Current certificate"
                        className="w-full h-48 object-contain rounded border bg-gray-50"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/default-certificate.jpg';
                        }}
                    />
                </div>
            );
        }
        return null;
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Certifications</h2>
                <button
                    onClick={() => {
                        resetForm();
                        setShowForm(true);
                    }}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                >
                    Add New Certification
                </button>
            </div>

            {showForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white p-6 rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold">
                                {editingId ? 'Edit Certification' : 'Add New Certification'}
                            </h3>
                            <button
                                onClick={resetForm}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>
                        
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Certification Name *
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.name}
                                        onChange={(e) => setFormData({...formData, name: e.target.value})}
                                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        required
                                        disabled={uploading}
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Issuing Authority *
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.issuer}
                                        onChange={(e) => setFormData({...formData, issuer: e.target.value})}
                                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        required
                                        disabled={uploading}
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Issue Date
                                    </label>
                                    <input
                                        type="date"
                                        value={formData.issue_date}
                                        onChange={(e) => setFormData({...formData, issue_date: e.target.value})}
                                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        disabled={uploading}
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Expiry Date
                                    </label>
                                    <input
                                        type="date"
                                        value={formData.expiry_date}
                                        onChange={(e) => setFormData({...formData, expiry_date: e.target.value})}
                                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        disabled={uploading}
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Certificate Number
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.certificate_number}
                                        onChange={(e) => setFormData({...formData, certificate_number: e.target.value})}
                                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        disabled={uploading}
                                    />
                                </div>
                                
                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Certificate Image/PDF
                                    </label>
                                    
                                    {/* File Upload Section */}
                                    <div className="space-y-4">
                                        {/* Upload Area */}
                                        <div 
                                            className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors cursor-pointer"
                                            onClick={() => !uploading && fileInputRef.current?.click()}
                                            onDragOver={handleDragOver}
                                            onDrop={handleDrop}
                                        >
                                            <input
                                                ref={fileInputRef}
                                                type="file"
                                                onChange={handleFileSelect}
                                                accept="image/*,.pdf"
                                                className="hidden"
                                                disabled={uploading}
                                            />
                                            <div className="flex flex-col items-center">
                                                <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                                                </svg>
                                                <p className="text-sm text-gray-600 mb-2">
                                                    <span className="font-semibold">Click to upload</span> or drag and drop
                                                </p>
                                                <p className="text-xs text-gray-500">
                                                    Images or PDF files up to 100MB
                                                </p>
                                            </div>
                                        </div>

                                        {/* Upload Progress */}
                                        {uploading && (
                                            <div className="w-full">
                                                <div className="flex justify-between text-sm text-gray-600 mb-1">
                                                    <span>Uploading to Railway...</span>
                                                    <span>{uploadProgress}%</span>
                                                </div>
                                                <div className="w-full bg-gray-200 rounded-full h-2">
                                                    <div 
                                                        className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                                        style={{ width: `${uploadProgress}%` }}
                                                    ></div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Preview */}
                                        {renderFilePreview()}

                                        {/* OR Separator */}
                                        <div className="relative">
                                            <div className="absolute inset-0 flex items-center">
                                                <div className="w-full border-t border-gray-300"></div>
                                            </div>
                                            <div className="relative flex justify-center text-sm">
                                                <span className="px-2 bg-white text-gray-500">OR</span>
                                            </div>
                                        </div>

                                        {/* URL Input */}
                                        <div>
                                            <p className="text-sm text-gray-600 mb-1">Enter Image URL directly:</p>
                                            <input
                                                type="url"
                                                value={formData.selectedFile ? '' : formData.image_url}
                                                onChange={(e) => setFormData({...formData, image_url: e.target.value, selectedFile: null, filePreview: null})}
                                                className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="https://example.com/certificate.jpg"
                                                disabled={uploading || !!formData.selectedFile}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    id="is_active"
                                    checked={formData.is_active}
                                    onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                    className="rounded text-blue-600 focus:ring-blue-500"
                                    disabled={uploading}
                                />
                                <label htmlFor="is_active" className="text-sm text-gray-700">
                                    Active
                                </label>
                            </div>
                            
                            <div className="flex justify-end space-x-3 pt-4">
                                <button
                                    type="button"
                                    onClick={resetForm}
                                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 disabled:opacity-50"
                                    disabled={uploading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={uploading || (!formData.selectedFile && !formData.image_url)}
                                >
                                    {uploading ? (
                                        <span className="flex items-center">
                                            <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            {formData.selectedFile ? 'Uploading...' : 'Saving...'}
                                        </span>
                                    ) : editingId ? 'Update Certification' : 'Add Certification'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                        <p className="mt-4 text-gray-600">Loading certifications...</p>
                    </div>
                </div>
            ) : certifications.length === 0 ? (
                <div className="text-center py-12">
                    <p className="text-gray-500 text-lg">No certifications found</p>
                    <p className="text-gray-400 mt-2">Add your first certification to get started</p>
                </div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Certificate
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Issuer
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Certificate No.
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Dates
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Status
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {certifications.map(cert => (
                                <tr key={cert.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4">
                                        <div className="flex items-center">
                                            {cert.image_url ? (
                                                <div className="relative group">
                                                    <img 
                                                        src={cert.image_url} 
                                                        alt={cert.name}
                                                        className="h-12 w-12 rounded-lg object-cover mr-3 border"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/default-certificate.jpg';
                                                        }}
                                                    />
                                                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-opacity rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100">
                                                        <a 
                                                            href={cert.image_url} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="text-white text-xs bg-blue-600 px-2 py-1 rounded"
                                                        >
                                                            View
                                                        </a>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center mr-3 border">
                                                    <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                </div>
                                            )}
                                            <div>
                                                <div className="text-sm font-medium text-gray-900">{cert.name}</div>
                                                <div className="text-xs text-gray-500 truncate max-w-[200px]">
                                                    {cert.image_url ? 'Certificate uploaded' : 'No certificate image'}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="text-sm text-gray-900">{cert.issuer}</div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="text-sm text-gray-900">{cert.certificate_number || '-'}</div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="text-sm text-gray-900">
                                            {cert.issue_date && new Date(cert.issue_date).toLocaleDateString()}
                                        </div>
                                        {cert.expiry_date && (
                                            <div className="text-xs text-gray-500">
                                                Expires: {new Date(cert.expiry_date).toLocaleDateString()}
                                            </div>
                                        )}
                                    </td>
                                    <td className="px-6 py-4">
                                        <button
                                            onClick={() => handleToggleActive(cert.id, cert.is_active)}
                                            className={`px-3 py-1 rounded-full text-xs font-medium ${
                                                cert.is_active 
                                                    ? 'bg-green-100 text-green-800' 
                                                    : 'bg-red-100 text-red-800'
                                            }`}
                                        >
                                            {cert.is_active ? 'Active' : 'Inactive'}
                                        </button>
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium">
                                        <div className="flex space-x-3">
                                            <button
                                                onClick={() => handleEdit(cert)}
                                                className="text-blue-600 hover:text-blue-900 flex items-center"
                                            >
                                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                </svg>
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDelete(cert.id)}
                                                className="text-red-600 hover:text-red-900 flex items-center"
                                            >
                                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default CertificationManager;